import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

import {
  IStringAnyMap,
  BooxMessageService,
} from 'lib-boox';
import {HERO_APPLICATIONS} from "../../token";

@Component({
  selector: 'hero-application-frame',
  standalone: true,
  imports: [],
  template: `
    <div class="hero-iframe-wrapper" >
        <iframe #appFrame [src]="iframeSrc" frameborder="0"  class="" allow="clipboard-write"></iframe>
    </div>`,
  styleUrl: './hero-application-frame.component.scss'
})
export class HeroApplicationFrameComponent implements AfterViewInit, OnDestroy, OnChanges {
  private iframeUrl: string = '';

  @ViewChild('appFrame') iFrame: ElementRef | undefined;

  /**
   * The name of the app to display in the iframe.
   */
  @Input('app') public appName: string | null = null;
  /**
   * The `view` and `resource` to display in the app.
   * These is appended to the app url and in not regulated by this component.
   */
  @Input('view') public appView: string | null = null;
  @Input('resource') public appViewResource: string | null = null;

  public iframeSrc: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
  public app: IStringAnyMap | null = null;

  constructor(
    private sanitizer: DomSanitizer,
    private message: BooxMessageService,
    @Inject(HERO_APPLICATIONS) public apps: IStringAnyMap[],
  ) { }

  // Lifecycle hooks

  // it doesn't matter which value changes, it needs to rebuild the iframe url
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appName'] && !!changes['appName'].previousValue && !changes['appName'].firstChange) {
      this.message.unbind(changes['appName'].previousValue);
    };

    this._buildUrl();
  }
  ngAfterViewInit(): void {
    this._buildUrl();
  }

  // Unbind the message service
  // when the component is destroyed
  ngOnDestroy() {
    if (this.appName) this.message.unbind(this.appName);
  }


  /**
   * Build the iframe url
   */
  private _buildUrl(): void {

    const app = this.apps.find(_app => _app['name'] === this.appName);
    if (!app) {
      console.error(`App with name ${this.appName} not found`);
      return;
    };
    let iframeUrl = app['path']; // Assuming it's a string
    if (!iframeUrl.endsWith('/')) iframeUrl += '/'; // Ensure it ends with '/'

    const pathSegments = [this.appView, this.appViewResource].filter(Boolean); // Remove undefined/null
    this.iframeUrl = iframeUrl + pathSegments.join('/');
    this.refreshFrameSrc();
  }


  /**
   * Refresh the iframe
   */
  public refreshFrameSrc() {
    if (this.appName) this.message.unbind(this.appName);
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl + '?t=' + Date.now());
    if (this.appName) this.message.bind(this.appName, this.iFrame?.nativeElement.contentWindow as Window);
  }
}
